/**
 * Mock Registry
 *
 * Mappa URL pattern → file mock JSON.
 * Supporta pattern esatti e pattern con wildcard (*).
 *
 * Esempi:
 * - Pattern esatto: '/api/v2/utente.php?token_login=1'
 * - Pattern con wildcard: '/api/v2/calendario.php*' (matcha qualsiasi query string)
 */

export const mockRegistry = {
  // Esempio: utente token login
  // '/api/v2/utente.php?token_login=1': 'utente-token-login.json',

  // Esempio: calendario (con wildcard per query string)
  // '/api/v2/calendario.php*': 'calendario.json',

  // Aggiungi qui i mapping URL → mock file
};

/**
 * Trova il file mock corrispondente all'URL
 * @param {string} url - URL della richiesta
 * @returns {string|null} - Nome del file mock o null se non trovato
 */
export function findMockFile(url) {
  // Prima cerca match esatto
  if (mockRegistry[url]) {
    return mockRegistry[url];
  }

  // Poi cerca pattern con wildcard
  for (const pattern in mockRegistry) {
    if (pattern.includes('*')) {
      const regexPattern = pattern
        .replace(/[.+?^${}()|[\]\\]/g, '\\$&') // Escape caratteri speciali regex
        .replace(/\*/g, '.*'); // Converti * in .*
      const regex = new RegExp(`^${regexPattern}$`);
      if (regex.test(url)) {
        return mockRegistry[pattern];
      }
    }
  }

  return null;
}

export default mockRegistry;
